/* global Swiper */

document.querySelectorAll( '.js-highlight-box' ).forEach( ( block ) => {

	const mmobileBreakpoint = matchMedia( '(max-width: 768px)' );
	if ( ! mmobileBreakpoint.matches ) {

		return;

	}
	const slider = block.querySelector( '.js-highlight-box-inner' );
	const wrapperEl = block.querySelector( '.js-highlight-box-grid' );
	const slides = slider.querySelectorAll( '.b-highlight-box-item' );
	wrapperEl.classList.remove( 'b-highlight-box-grid' );
	slides.forEach( ( slide ) => {

		slide.classList.add( 'swiper-slide' );

	} );
	slider.classList.add( 'swiper' );
	wrapperEl.classList.add( 'swiper-wrapper' );

	new Swiper( slider, {
		loop: false,
		slidesPerView: 1.05,
		spaceBetween: 12,
		watchOverflow: true,
		slideClass: 'b-highlight-box-item',
	} );

} );
